export enum BrowserStorageKey {
  ACCESS_TOKEN = 'ACCESS_TOKEN',
  EXPIRES_IN = 'EXPIRES_IN',
  REFRESH_TOKEN = 'REFRESH_TOKEN',
  LOGGED_TIME = 'LOGGED_TIME',
  INIT_TEAM= 'INIT_TEAM'
}
